import React from "react";
import { useTheme } from "@mui/material";
import { useGetTotalCompanyQuery } from "../../services/report.service";
import DonutChartData from "../../components/global/DonutChartData";

interface DonutChartCustomerProps {
  id?: string;
}

const DonutChartCustomer: React.FC<DonutChartCustomerProps> = ({ id }) => {
  const { data, isFetching, isLoading } = useGetTotalCompanyQuery();
  const theme = useTheme();

  const dataMapper = React.useCallback(
    (data: any, theme: any) => [
      {
        name: "Active",
        value: data?.total_active || 0,
        color: theme.palette.primary.main,
      },
      {
        name: "Not Active",
        value: data?.total_inactive || 0,
        color: theme.palette.grey[500],
      },
      {
        name: "Idle",
        value: data?.total_idle || 0,
        color: theme.palette.secondary.main,
      },
    ],
    []
  );

  return (
    <DonutChartData
      id={id}
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      dataMapper={dataMapper}
    />
  );
};

export default DonutChartCustomer;
